import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "../../components/AppToast";
import StockTransferInList from "./StockTransferInList";
import AddStockTransferIn from "./AddStockTransferIn";
import {
  extractStockTransferInId,
  getStockTransferInById,
} from "../../services/stockTransferIn/stockTransferIn";

export default function StockTransferInManagement() {
  const [isCreating, setIsCreating] = useState(false);
  const [viewDoc, setViewDoc] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [listVersion, setListVersion] = useState(0);

  const closeSubView = () => {
    setIsCreating(false);
    setViewDoc(null);
    setViewLoading(false);
    setListVersion((v) => v + 1);
  };

  const transferLabel =
    viewDoc?.transferNumber ??
    viewDoc?.transferInNo ??
    viewDoc?.transferInNumber ??
    "";

  const headerTitle = viewDoc
    ? "View Stock Transfer In"
    : isCreating
      ? "Create Stock Transfer In"
      : "Stock Transfer In";

  const breadcrumbLeaf = viewLoading
    ? "Loading…"
    : viewDoc
      ? transferLabel
        ? `View ${transferLabel}`
        : "View transfer in"
      : isCreating
        ? "Create Stock Transfer In"
        : null;

  return (
    <div className="card shadow-lg main-card">
      <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0 h6 fw-semibold">{headerTitle}</h4>
      </div>

      {(isCreating || viewDoc || viewLoading) && (
        <nav aria-label="breadcrumb" className="px-3 py-2 border-bottom bg-light">
          <ol
            className="breadcrumb mb-0 align-items-center"
            style={{ "--bs-breadcrumb-divider": "'/'" }}
          >
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={closeSubView}
                disabled={viewLoading}
              >
                Stock Transfer In
              </button>
            </li>
            {breadcrumbLeaf && (
              <li
                className="breadcrumb-item active fw-semibold text-primary"
                aria-current="page"
              >
                {breadcrumbLeaf}
              </li>
            )}
          </ol>
        </nav>
      )}

      <div className="card-body">
        {viewLoading ? (
          <div className="d-flex align-items-center gap-2 py-5 justify-content-center text-muted">
            <Spinner animation="border" size="sm" />
            Loading stock transfer in…
          </div>
        ) : viewDoc ? (
          <AddStockTransferIn
            key={
              extractStockTransferInId(viewDoc) ||
              (viewDoc?._id != null ? String(viewDoc._id) : "") ||
              "sti-view"
            }
            viewOnly
            initialDocument={viewDoc}
            onCancel={closeSubView}
          />
        ) : isCreating ? (
          <AddStockTransferIn
            onCancel={() => {
              setIsCreating(false);
              setListVersion((v) => v + 1);
            }}
          />
        ) : (
          <StockTransferInList
            refreshKey={listVersion}
            onCreateClick={() => setIsCreating(true)}
            onView={async (row) => {
              const id =
                extractStockTransferInId(row) ||
                String(row?._id || "").trim() ||
                String(row?.id || "").trim();
              if (!id || /^sti-row-/i.test(id)) {
                toast.error(
                  "Cannot open this record: missing document id. Refresh the list and try again."
                );
                return;
              }
              setViewLoading(true);
              setViewDoc(null);
              setIsCreating(false);
              try {
                const doc = await getStockTransferInById(id);
                setViewDoc(doc);
              } catch (err) {
                toast.error(err?.message || "Failed to load stock transfer in");
              } finally {
                setViewLoading(false);
              }
            }}
          />
        )}
      </div>
    </div>
  );
}
